import { Font } from '@react-pdf/renderer';

export const PDF_FONT_FAMILY = 'ConversationPdfFont';

interface PdfFontDefinition {
  fontStyle?: 'italic';
  fontWeight: 400 | 700;
  src: string;
}

interface PdfFontModule {
  register: (input: { family: string; fonts: PdfFontDefinition[] }) => void;
}

const pdfFont = Font as unknown as PdfFontModule;

pdfFont.register({
  family: PDF_FONT_FAMILY,
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/arimo/v35/P5sfzZCDf9_T_3cV7NCUECyoxNk37cxsBw.ttf',
      fontWeight: 400,
    },
    {
      src: 'https://fonts.gstatic.com/s/arimo/v35/P5sfzZCDf9_T_3cV7NCUECyoxNk3CstsBw.ttf',
      fontWeight: 700,
    },
    {
      src: 'https://fonts.gstatic.com/s/arimo/v35/P5sdzZCDf9_T_10c3i9MeUcyat4iJY-ERBrE.ttf',
      fontStyle: 'italic',
      fontWeight: 400,
    },
  ],
});
